export default __webpack_public_path__ + "static/video-scroll-7d2fe88e73bcfd0afa8aa9eeb541a236.mp4";